<template>
    <TemplatesToursPage />
</template>
